<template>
	<div id="start-account-button">
		<b-button
			:class="['has-icon', buttonClass]"
			icon-left="plus"
			:type="buttonType"
			label="Start an Account"
			v-on:click="showModal" />
		<b-modal
			class="has-text-left"
			:active.sync="modalActive"
			v-on:close="resetModal"
			has-modal-card>
			<div class="modal-card">
				<form @submit.prevent="createAccount">
					<header class="modal-card-head">
						<p class="modal-card-title" style="margin: 0">Start an Account</p>
					</header>
					<section class="modal-card-body">
						<p>Create a new Account by entering the account name below. After clicking the Create Account button, you can upload files.</p>
						<b-field
							label="Account Name"
							:type="errors.name ? 'is-danger' : ''"
							:message="errors.name ? errors.name[0] : ''">
							<b-input v-model="name"
							         ref="name"
							         type="text"
							         autofocus>
							</b-input>
						</b-field>
						<b-field
							label="Account #"
							:type="errors.name ? 'is-danger' : ''"
							:message="errors.name ? errors.name[0] : ''">
							<b-input v-model="account_number"
							         placeholder="Ex. 23456"
							         ref="account_number"
							         type="text">
							</b-input>
						</b-field>
						<b-field v-if="userCan('create_standard_accounts', 'accounts')"
						         label="How would you like your data added and organized in Griptiller?"
						         :type="errors.file_retrieval_method ? 'is-danger' : ''"
						         :message="errors.file_retrieval_method ? errors.file_retrieval_method[0] : ''">
							<b-select placeholder="Organization Method" v-model="file_retrieval_method">
								<option value="upload">I will do it manually.</option>
								<option value="assisted">I want Griptiller to do it.</option>
							</b-select>
						</b-field>

					</section>
					<footer class="modal-card-foot has-text-right" style="display: block">
						<button class="button" type="button" @click="closeModal">Cancel</button>
						<button
							v-bind:class="{ 'is-loading' : loading }"
							class="button is-primary"
							type="submit">Create Account
						</button>
					</footer>
				</form>
			</div>
		</b-modal>
	</div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { FORM_CREATE } from '../../store/actions/form'

export default {
  name: 'SimpleAccountButton',
  props: {
    buttonClass: {
      default: ''
    },
    buttonType: {
      default: 'is-primary'
    }
  },
  data: function () {
    return {
      modalActive: false,
      name: null,
      account_number: null,
      account_manage: null,
      file_retrieval_method: null,
      loading: false,
      errors: {}
    }
  },

  computed: {
    ...mapGetters({
      userCan: 'userCan'
    })
  },
  methods: {
    showModal () {
      this.modalActive = true
      this.$nextTick(() => {
        this.$refs.name.focus()
      })
    },
    closeModal () {
      this.modalActive = false
      this.resetModal()
    },
    resetModal () {
      this.name = null
      this.account_number = null
      this.file_retrieval_method = null
      this.loading = false
      this.errors = {}
    },
    createAccount () {
      this.errors = {}
      this.loading = true

      const model = 'accounts'
      const fields = {
        name: this.name,
        account_number: this.account_number,
        file_retrieval_method: this.file_retrieval_method,
        type: 'managed'
      }

      this.$store.dispatch(FORM_CREATE, { model, fields }).then(response => {
        this.$router.push({
          name: 'account-dashboard',
          params: {
            id: response.data.id
          }
        })
      }).catch(error => {
        if (error.response.status === 400 && _.has(error.response.data, 'errors')) {
          this.errors = error.response.data.errors
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Account/SimpleAccountButton.vue